var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighSeverity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461.6,230.97h.13c-12.04-18.15-36.47-23.19-54.71-11.27l-112.74,74.26c18.57,19.17,32.76,42.14,41.58,67.33l114.71-75.56c18.11-12.11,23.04-36.57,11.04-54.76"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.66,222.21l-33.22,21.88c14.13,21.37,22.3,46.25,23.48,72.07l50-32.94c16.66-11.14,21.24-33.85,10.19-50.6l.08-.05c-11.11-16.67-33.76-21.32-50.53-10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.05,317.79h.05c-.06,2.76,2.14,5.04,4.9,5.1h87.1c2.7,0,4.91-2.14,5-4.83,1.08-33.5,13.95-65.55,36.33-90.51l-68.69-68.55c-40.45,43.11-63.5,99.68-64.69,158.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.94,147.59c-42.4-39.77-97.84-62.73-155.94-64.59v97c32.39,1.77,63.2,14.53,87.35,36.18l68.59-68.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.27,158.95l-68.6,68.6c3.33,3.72,6.45,7.6,9.35,11.61l33.35-21.96c19.55-12.78,45.96-7.34,58.86,12.12.15.23.27.48.35.74,12.26,19.42,6.83,45.36-12.35,58.18l-51.16,33.7c.83.6,1.83.96,2.93.96h87.1c2.76-.06,4.96-2.34,4.9-5.1-1.19-59.13-24.25-115.72-64.73-158.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254,308.13c-33.36,0-60.4,27.04-60.4,60.4s27.04,60.4,60.4,60.4,60.4-27.04,60.4-60.4-27.04-60.4-60.4-60.4ZM246,333c0-4.42,3.58-8,8-8s8,3.58,8,8v37.79c0,4.42-3.58,8-8,8s-8-3.58-8-8v-37.79ZM254,404.18c-4.46,0-8.07-3.61-8.07-8.07s3.61-8.07,8.07-8.07,8.07,3.61,8.07,8.07-3.61,8.07-8.07,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248,83c-58.11,1.86-113.54,24.82-155.94,64.6l68.59,68.59c24.16-21.63,54.97-34.38,87.35-36.14v-97.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighSeverity);
export default __webpack_public_path__ + "static/media/highSeverity.5ff8844fee29f965488ad15a205d59d1.svg";
export { ForwardRef as ReactComponent };